<template>
  <div>
    <div class="modals">
      <b-modal
        class="modalConfirmPass"
        :modal-class="true ? 'in':''"
        :hide-header-close="true"
        :title-tag="'h4'"
        cancel-title="Annuler"
        id="modalConfirmPass"
        ref="modal"
        title="Confirmez par votre mot de passe actuel"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group well">
              <form ref="form" @submit.stop.prevent="saveProfile">
                <b-form-group
                  :state="passState"
                  label="Mot de passe actuel"
                  label-for="pass-input"
                  invalid-feedback="Le mot de passe est requis"
                >
                  <b-form-input
                    id="pass-input"
                    type="password"
                    v-model="actualPassword"
                    :state="passState"
                    required
                  ></b-form-input>
                </b-form-group>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div class="content-wrapper">
      <section class="content-header">
        <h1>
          Profil
          <small></small>
        </h1>
        <ol class="breadcrumb">
          <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
          <li class="active"><a href="#">Profil</a></li>
        </ol>
      </section>

      <section class="content">
        <div class="row">
          <div class="col-md-6">
            <div class="box box-primary">
              <div class="box-header with-border">
                <h3 class="box-title">
                  {{getMainUser.name}}
                </h3>
              </div>
              <div class="box-body">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="avatar">Avatar</label>
                    <div class="row">
                      <img
                        class="img-thumbnail"
                        v-if="getMainUser.avatar"
                        width="100"
                        height="100"
                        :src="getMainUser.avatar">

                      <a class="btn btn-primary btn-flat margin "
                         @click="show_upload_avatar=!show_upload_avatar">Changer la photo de profil
                      </a>

                      <!--                  <a class="btn btn-primary btn-flat margin " v-if="getMainUser.avatar" @click="getMainUser.avatar=null">-->
                      <!--                    Enlever <br/>cette photo de profil-->
                      <!--                  </a>-->
                    </div>
                    <my-upload field="img"
                               @crop-success="cropSuccess"
                               @crop-upload-success="cropUploadSuccess"
                               @crop-upload-fail="cropUploadFail"
                               v-model="show_upload_avatar"
                               :width="300"
                               :height="300"
                               langType="fr"
                               :noCircle="true"
                               img-format="jpg">
                    </my-upload>
                  </div>
                </div>
                <div class="form-group"
                     :class="{'has-error': errors.has('mainuser[mail]') }">
                  <label for="mail">E-mail</label>
                  <input type="text" class="form-control" id="mail" name="mainuser[mail]"
                         disabled
                         placeholder="Mail" v-model="getMainUser.email">
                </div>
                <div class="form-group"
                     :class="{'has-error': errors.has('mainuser[nom]') }">
                  <label for="nom">Nom</label>
                  <input type="text" class="form-control" id="nom" name="mainuser[nom]"
                         v-validate="'max:255'"
                         placeholder="Nom" v-model="getMainUser.name">
                  <span v-show="errors.has('mainuser[nom]')" class="help-block">Votre nom doit comporter moins de 255 caractères</span>
                </div>

                <div class="form-group"
                     :class="{'has-error': errors.has('mainuser[pass1]') }">
                  <label for="pass1">Nouveau mot de passe</label>
                  <input type="password" class="form-control" id="pass1" name="mainuser[pass1]"
                         v-validate="'min:6|max:255'"
                         placeholder="Mot de passe" v-model="getMainUser.pass1">
                  <span v-show="errors.has('mainuser[pass1]')" class="help-block">Votre mot de passe doit comporter entre 6 et 255 caractères</span>
                </div>
                <div class="form-group"
                     :class="{'has-error': errors.has('mainuser[pass2]') }">
                  <label for="pass1">Confirmation du nouveau mot de passe</label>
                  <input type="password" class="form-control" id="pass2" name="mainuser[pass2]"
                         v-validate="'min:6|max:255|confirmed:mainuser[pass1]'"
                         placeholder="Mot de passe" v-model="getMainUser.pass2">
                  <span v-show="errors.has('mainuser[pass2]')" class="help-block">Vos mots de passe doivent correspondre</span>
                </div>


                <div class="box-footer">
                  <b-button
                    v-b-modal.modalConfirmPass
                    type="button"
                    class="btn btn-lg btn-primary btn-flat margin pull-right"
                    :disabled="errors.count()!=0"
                  >
                    Sauvegarder
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';
    import Auth from '@/auth'
    import cropUpload from '../Communs/ImgCropUpload'
    var $ = require('jquery');
    var _ = require('underscore')
    var moment = require('moment')

    export default {
        data() {
            return {
                passState: null,
                actualPassword: "",
                show_upload_avatar: false,
            }
        },
        components: {
            'my-upload': cropUpload
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
                getMainUser: 'getMainUser',
            }),
        },
        mounted: function () {
            var these = this
            this.$nextTick(function () {
            })
        },
        methods: {
            cropSuccess(imgDataUrl, field) {
                this.getMainUser.avatar = imgDataUrl;
            },
            cropUploadSuccess(jsonData, field) {
            },
            cropUploadFail(status, field) {
            },

            checkFormValidity() {
                return this.actualPassword != ""
            },
            resetModal() {
                this.actualPassword = ""
            },
            getForm: function () {
                return {
                    name: this.getMainUser.name,
                    password: this.getMainUser.pass1,
                    actualPassword: this.actualPassword,
                    avatar: this.getMainUser.avatar
                }
            },
            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault()
                this.saveProfile()
            },

            saveProfile: function () {
                let self = this;
                if (!this.checkFormValidity()) {
                    self.$noty.error("Le mot de passe ne peut être vide")
                    return
                }
                this.$http.post(this.getRoute('updateProfile'), this.getForm()).then(function (response) {
                    self.$noty.success("Profil mis à jour. Veuillez vous reconnecter.")
                    self.$bvModal.hide('modalConfirmPass')
                    self.resetModal();
                    Auth.logout()
                }, (response) => {
                    self.$noty.error("Erreur dans la mise à jour du profil")
                    self.$bvModal.hide('modalConfirmPass')
                    self.resetModal();
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Administration/Profile.vue